Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.TextFormatAlign = module.exports.default = {
	CENTER: "center",
	END: "end",
	JUSTIFY: "justify",
	LEFT: "left",
	RIGHT: "right",
	START: "start"
};